export const AUTH_TOKEN = 'token';
export const USER_TYPE = 'user_type';
export const USER_NAME = 'user_name';
export const USER_BRANCH = "user_branch";
export const USER_ID = "user_id";
